import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { useDispatch, useSelector } from "react-redux";
import { getAgentById, updateAgent, deleteAgent } from "../../model/agents";
import s from "./styles.module.css"

const AgentEditModal = ({ open, onClose, agentId }) => {
    const dispatch = useDispatch();
    const token = useSelector((state) => state.auth.refresh_token);
    const agentData = useSelector((state) => state.agents.agent);
    const loading = useSelector((state) => state.agents.loading);
    const [editedAgent, setEditedAgent] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const userRole = localStorage.getItem("role");




    useEffect(() => {
        if (agentId) {
            dispatch(getAgentById({ id: agentId, token }));
        }
    }, [agentId, dispatch, token]);

    useEffect(() => {
        if (agentData) {
            setEditedAgent(agentData);
        }
    }, [agentData]);

    const handleSaveChanges = async () => {
        if (editedAgent) {
            const formData = new FormData();

            formData.append("name", editedAgent.name);
            formData.append("surname", editedAgent.surname);
            formData.append("phone_number", editedAgent.phone_number);
            formData.append("whats_app", editedAgent.whats_app);
            formData.append("email", editedAgent.email);
            formData.append("group", editedAgent.group);

            // Если фото было обновлено
            if (editedAgent.photo instanceof File) {
                formData.append("photo", editedAgent.photo);
            }



            await dispatch(updateAgent({ id: agentData.id, updatedData: formData, token }));
            setIsEditing(false);
            onClose();
        }
    };


    const handleDeleteAgent = async () => {
        await dispatch(deleteAgent({ id: agentId, token }));
        onClose();
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    backgroundColor: "white",
                    padding: 4,
                    borderRadius: 2,
                    boxShadow: 24,
                    minWidth: 400,
                }}
            >
                {loading ? (
                    <Typography>Загрузка...</Typography>
                ) : editedAgent ? (
                    <>
                        {isEditing ? (
                            <>
                                <div className={s.photoEditWrapper}>
                                    <div className={s.photoPreview}>
                                        <img
                                            src={
                                                editedAgent.photo instanceof File
                                                    ? URL.createObjectURL(editedAgent.photo)
                                                    : `${process.env.REACT_APP_API_URL}/api/v1/property/${editedAgent.photo}?t=${Date.now()}`
                                            }
                                            alt="Фото агента"
                                            className={s.previewImage}
                                        />
                                    </div>
                                    <Button
                                        variant="contained"
                                        component="label"
                                        sx={{mt: 2}}
                                    >
                                        Изменить фото
                                        <input
                                            type="file"
                                            hidden
                                            accept="image/*"
                                            onChange={(e) => {
                                                const file = e.target.files[0];
                                                if (file) {
                                                    setEditedAgent({...editedAgent, photo: file});
                                                }
                                            }}
                                        />
                                    </Button>
                                </div>
                                <TextField
                                    label="Имя"
                                    fullWidth
                                    value={editedAgent.name}
                                    onChange={(e) => setEditedAgent({...editedAgent, name: e.target.value})}
                                    margin="normal"
                                />
                                <TextField
                                    label="Фамилия"
                                    fullWidth
                                    value={editedAgent.surname}
                                    onChange={(e) => setEditedAgent({...editedAgent, surname: e.target.value})}
                                    margin="normal"
                                />
                                <TextField
                                    label="Телефон"
                                    fullWidth
                                    value={editedAgent.phone_number}
                                    onChange={(e) => setEditedAgent({...editedAgent, phone_number: e.target.value})}
                                    margin="normal"
                                />
                                <TextField
                                    label="Whatsapp"
                                    fullWidth
                                    value={editedAgent.whats_app}
                                    onChange={(e) => setEditedAgent({...editedAgent, whats_app: e.target.value})}
                                    margin="normal"
                                />
                                <TextField
                                    label="Email"
                                    fullWidth
                                    value={editedAgent.email}
                                    onChange={(e) => setEditedAgent({...editedAgent, email: e.target.value})}
                                    margin="normal"
                                />
                                <TextField
                                    label="Группа"
                                    fullWidth
                                    value={editedAgent.group}
                                    onChange={(e) => setEditedAgent({...editedAgent, group: e.target.value})}
                                    margin="normal"
                                />
                                <Box sx={{display: "flex", justifyContent: "space-between"}}>
                                    <Button
                                        variant="outlined"
                                        onClick={() => setIsEditing(false)}
                                        sx={{mt: 2}}
                                    >
                                        Назад
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleSaveChanges}
                                        sx={{mt: 2}}
                                    >
                                        Сохранить
                                    </Button>
                                </Box>

                            </>
                        ) : (
                            <div className={s.agentsDetailWrapper}>
                                {editedAgent.photo && (
                                    <div className={s.photoWrapper}>
                                        <img
                                            src={`${process.env.REACT_APP_API_URL}/api/v1/property/${editedAgent.photo}?t=${Date.now()}`}
                                            alt="Фото агента"
                                        />
                                    </div>
                                )}
                                <h1>{editedAgent.name} {editedAgent.surname}</h1>
                                <div className={s.agentDetails}>
                                    <p>
                                        <span>Телефон:</span>
                                        <span>{editedAgent.phone_number}</span>
                                    </p>
                                    <p>
                                        <span>Whatsapp:</span>
                                        <span>{editedAgent.whats_app}</span>
                                    </p>
                                    <p>
                                        <span>Email:</span>
                                        <span>{editedAgent.email}</span>
                                    </p>
                                    <p>
                                        <span>Группа:</span>
                                        <span>{editedAgent.group}</span>

                                    </p>
                                </div>
                                {userRole === "super_admin" && (
                                    <Box sx={{ mt: 2, width: "100%", display: "flex", justifyContent: "space-between" }}>
                                        <Button
                                            variant="outlined"
                                            onClick={() => setIsEditing(true)}
                                            sx={{ mr: 1, textTransform: "none" }}
                                        >
                                            Редактировать
                                        </Button>
                                        <Button
                                            variant="contained"
                                            color="error"
                                            onClick={handleDeleteAgent}
                                            sx={{ textTransform: "none" }}
                                        >
                                            Удалить
                                        </Button>
                                    </Box>
                                )}
                            </div>
                        )}
                    </>
                ) : (
                    <Typography>Ошибка загрузки данных агента</Typography>
                )}
            </Box>
        </Modal>
    );
};

export default AgentEditModal;
